/* eslint-disable react-hooks/exhaustive-deps */
import { Button, rem } from '@mantine/core';
import { PlusIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import AddNewCardModal from '../add-new-card-modal';
import ModalWrapper from '@/components/modals/modal-wrapper';

const ButtonAddCard = () => {
  const tPayment = useTranslations('payment');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const handleOpenModalAddCard = () => {
    open();
  };

  return (
    <>
      <Button
        p={0}
        color="secondary.4"
        leftSection={<PlusIcon className="size-5" />}
        size="sm"
        variant="transparent"
        onClick={handleOpenModalAddCard}
      >
        {tPayment('link_now')}
      </Button>
      <ModalWrapper
        title={tPayment('link')}
        isOpen={isOpen}
        onClose={close}
        optionStyle={{
          headerStyle: {
            minHeight: rem(56),
            borderBottom: `1px solid var(--mantine-color-neutral-0)`,
            paddingLeft: rem(16),
          },
          bodyStyle: {
            padding: 0,
          },
        }}
      >
        <AddNewCardModal />
      </ModalWrapper>
    </>
  );
};
export default ButtonAddCard;
